<div class="flex w-full flex-col items-center gap-8">
  <h1 class="">
    {{ 'login.title' | translate }}
  </h1>

  <pl-loader *ngIf="isLoading"></pl-loader>
  <div class="w-full bg-pl-error p-4 text-sm italic text-white" [hidden]="!error || isLoading">
    {{ error }}
  </div>

  <form
    *ngIf="!isLoading"
    class="flex w-full flex-col items-center gap-8"
    [formGroup]="loginForm"
    (ngSubmit)="login()"
    #myLoginForm="ngForm"
  >
    <pl-input
      #plInputUsername
      class="w-full"
      [autocomplete]="'username'"
      [formControlName]="FormControlName.username"
      [isFormSubmitted]="myLoginForm.submitted"
      [label]="'login.username_label' | translate"
      [requiredErrorMessage]="'login.errors.enter_username_or_email' | translate"
      [showRightIcon]="false"
    />
    <pl-input
      #plInputPassword
      class="w-full"
      [autocomplete]="'password'"
      [formControlName]="FormControlName.password"
      [isFormSubmitted]="myLoginForm.submitted"
      [label]="'login.password_label' | translate"
      [requiredErrorMessage]="'login.errors.enter_password' | translate"
      [showEyeIconToTogglePassword]="true"
      [showRightIcon]="false"
      [type]="PlInputType.password"
    />
    <pl-button
      class="block w-full"
      [variant]="ButtonVariant.blue"
      [type]="PlButtonType.submit"
      [padding]="ButtonPadding.big"
    >
      {{ 'login.title' | translate }}
    </pl-button>
  </form>

  <a (click)="showForgotPasswordScreen()" class="cursor-pointer text-lg text-pl-blue-500">
    {{ 'login.forgot_login_details' | translate }}
  </a>
</div>
